@if (selectedRecording(); as recording) {
  @if (isLoading()) {
    <div class="spinner-container">
      <mat-spinner class="absolute-centered" mode="indeterminate" [diameter]="150"></mat-spinner>
    </div>
  }
  @if (!isLoading() && recording) {
    <div class="recording-container">
      <div class="grid-container">
        <div class="main-content">
          @if (recording.externalVideoId) {
            <div class="video-section">
              <div class="video-wrapper">
                <iframe
                  loading="lazy"
                  title="Gumlet video player"
                  [src]="getSafeVideoUrl(recording.externalVideoId)"
                  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen"
                >
                </iframe>
              </div>
            </div>
          } @else {
            <div class="no-video">
              <p>No video is available for preview.</p>
            </div>
          }
          <div>
            <div class="subject">{{ recording.subject }}</div>
            <div class="date">{{ recording.createdAt | date: 'dd MMMM, yyyy' }}</div>
          </div>
          <div class="containers">
            <div class="description-container">
              <p class="label">Description</p>
              <div class="rich-text" [innerHtml]="recording.shortDescription | parseHtml"></div>
            </div>
            @if (recording.keywords.length > 0) {
              <div class="keywords-container">
                <p class="label">Keywords</p>
                @for (keyword of recording.keywords; track keyword) {
                  <div class="keyword-item">{{ keyword }}</div>
                }
              </div>
            }
            @if (recording.fieldExperts.length > 0) {
              <div class="authors-container">
                <p class="label">Speakers</p>
                <div class="flex">
                  @for (author of recording.fieldExperts; track author) {
                    <div class="author-item">
                      <img
                        [src]="
                          author.pictureId
                            ? environment.bffUrl + '/file-management/files/' + author.pictureId + '/image'
                            : '/assets/avatar.png'
                        "
                        alt=""
                        loading="lazy"
                      />
                      <div>
                        <p class="author-name">{{ author.firstName }} {{ author.lastName }}</p>
                        <small>{{ author.jobTitle }}</small>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
        <div class="side-content">
          <div class="containers">
            <div class="language-container">
              <p class="label">Language</p>
              <div class="flex">
                <p>{{ recording.languageName }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
